import '@ant-design/compatible/assets/index.css';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import authControl from '~components/auth-control';
import { entityAction, platformEntity } from '~constants';
import Promotion from '~pages/dashboard/referral/promotion/list';
@withTranslation()
@authControl(platformEntity.IDENTITY_CMS_USERS, entityAction.READ)
class PromotionPage extends React.Component {
  constructor() {
    super();

    this.state = {};
  }

  componentDidMount() {}

  render() {
    // const { userInfo } = this.state;
    // const currentRole = this.getCurrentRole();

    return <Promotion />;
  }
}

export default PromotionPage;

PromotionPage.propTypes = {
  t: PropTypes.func,
  history: PropTypes.object,
  auth: PropTypes.shape({
    currentRoleSlug: PropTypes.string,
  }),
  cmsUser: PropTypes.object,
};

PromotionPage.defaultProps = {
  t: () => {},
  history: '',
  auth: {},
  cmsUser: {},
};
